import React, { Fragment } from "react";
import Image from "@vorne/gatsby-theme-marketing/components/image/image";
import Grid from "@vorne/gatsby-theme-marketing/components/layout/grid/grid";
import { graphql } from "gatsby";
import {
  Heading1,
  Body1,
} from "@vorne/gatsby-theme-marketing/components/typography/typography";
import QuickLinks from "@vorne/gatsby-theme-marketing/components/quicklinks/quickLinks";
import PageTitle from "@vorne/gatsby-theme-marketing/components/pagetitle/pageTitle";
import Page from "../../../../components/page";
import Section from "@vorne/gatsby-theme-marketing/components/section/section";
import Center from "@vorne/gatsby-theme-marketing/components/layout/center/center";
import { Seo } from "@vorne/gatsby-theme-marketing/components/seo/v2";

const XL600LegendPlates = ({ data }) => {
  return (
    <Page>
      <Section>
        <PageTitle>XL600 Legend Plates</PageTitle>
        <QuickLinks tag="h2" />
        <Center $horizontally>
          <Image
            src={data.vorneXl600Image}
            alt="Image of the XL600 display."
            renderCaption={() => (
              <Fragment>XL600-3T (3-Line, Tricolor LED)</Fragment>
            )}
          />
        </Center>
        <Body1>
          Tailor the XL600 to your application with interchangeable legend
          plates featuring terms of your choice. We have dozens of standard
          terms to choose from as listed below. Custom terms are also available
          – please consult the factory. These legend plates have been designed
          specifically for the XL600 and in just seconds can easily be replaced
          in the field. Each legend plate features bold white heavy duty vinyl
          lettering, measures 15.6″ x 3.0″ and is secured with 4 machine screws.
        </Body1>
        <Heading1 id="standardTermsAlphabetized">
          Standard Terms - Alphabetized
        </Heading1>
        <Grid $desktop="25 25 25 25" $verticalAlign="top">
          <div>
            <Body1>
              <strong>A</strong>
            </Body1>
            <Body1>Accepted</Body1>
            <Body1>Accidents</Body1>
            <Body1>Actual</Body1>
            <Body1>Actual / Hour</Body1>
            <Body1>Actual / Shift</Body1>
            <Body1>Availability</Body1>
            <Body1>Average Cycle</Body1>
            <Body1>Average Rate</Body1>
            <Body1>Avg. Speed</Body1>
            <Body1>
              <strong>C</strong>
            </Body1>
            <Body1>Count (Hour)</Body1>
            <Body1>Count (Shift)</Body1>
            <Body1>Current Cycle</Body1>
            <Body1>Current Shift</Body1>
            <Body1>Cycle Time</Body1>
            <Body1>
              <strong>D</strong>
            </Body1>
            <Body1>Date</Body1>
            <Body1>Day</Body1>
            <Body1>Difference</Body1>
            <Body1>Down Time</Body1>
            <Body1>
              <strong>E</strong>
            </Body1>
            <Body1>Efficiency</Body1>
            <Body1>Event DT</Body1>
          </div>
          <div>
            <Body1>
              <strong>F</strong>
            </Body1>
            <Body1>Feet / Min</Body1>
            <Body1>
              <strong>G</strong>
            </Body1>
            <Body1>Goal</Body1>
            <Body1>Goal (Daily)</Body1>
            <Body1>Goal (Hour)</Body1>
            <Body1>Goal (Job)</Body1>
            <Body1>Goal (Monthly)</Body1>
            <Body1>Goal (Shift)</Body1>
            <Body1>Goal (Weekly)</Body1>
            <Body1>Good Count</Body1>
            <Body1>
              <strong>L</strong>
            </Body1>
            <Body1>Last Cycle</Body1>
            <Body1>Last Hour</Body1>
            <Body1>Last Shift</Body1>
            <Body1>Line 1</Body1>
            <Body1>Line 2</Body1>
            <Body1>Line 3</Body1>
            <Body1>Line 4</Body1>
            <Body1>Line Speed</Body1>
            <Body1>
              <strong>M</strong>
            </Body1>
            <Body1>Machine</Body1>
            <Body1>Month</Body1>
            <Body1>
              <strong>N</strong>
            </Body1>
            <Body1>Next WO</Body1>
          </div>
          <div>
            <Body1>
              <strong>O</strong>
            </Body1>
            <Body1>OEE %</Body1>
            <Body1>
              <strong>P</strong>
            </Body1>
            <Body1>Pace +/-</Body1>
            <Body1>Performance</Body1>
            <Body1>Pieces to Goal</Body1>
            <Body1>
              <strong>Q</strong>
            </Body1>
            <Body1>Quality %</Body1>
            <Body1>
              <strong>R</strong>
            </Body1>
            <Body1>Reject Count</Body1>
            <Body1>Rejected</Body1>
            <Body1>Run Rate</Body1>
            <Body1>Run Time</Body1>
            <Body1>
              <strong>S</strong>
            </Body1>
            <Body1>Scheduled</Body1>
            <Body1>Scrap %</Body1>
            <Body1>Setup Time</Body1>
            <Body1>Shift A</Body1>
            <Body1>Shift B</Body1>
            <Body1>Shift C</Body1>
            <Body1>Shift DT</Body1>
            <Body1>Standby Time</Body1>
          </div>
          <div>
            <Body1>
              <strong>T</strong>
            </Body1>
            <Body1>Takt Target</Body1>
            <Body1>Takt Time</Body1>
            <Body1>Target</Body1>
            <Body1>Target / Hour</Body1>
            <Body1>Target Count</Body1>
            <Body1>Target Cycle</Body1>
            <Body1>Time</Body1>
            <Body1>Total Count</Body1>
            <Body1>Total DT</Body1>
            <Body1>Total Feet</Body1>
            <Body1>Total Time</Body1>
            <Body1>Total Yards</Body1>
            <Body1>
              <strong>U</strong>
            </Body1>
            <Body1>Unit Count</Body1>
            <Body1>Up Time</Body1>
            <Body1>Up Time %</Body1>
            <Body1>
              <strong>V</strong>
            </Body1>
            <Body1>Variance</Body1>
            <Body1>
              <strong>W</strong>
            </Body1>
            <Body1>Wait Time</Body1>
            <Body1>Week</Body1>
            <Body1>Week Target</Body1>
            <Body1>Weekly Total</Body1>
            <Body1>WO</Body1>
            <Body1>Work Order #</Body1>
            <Body1>WIP</Body1>
          </div>
        </Grid>
        <Heading1 id="standardTermsByCategory">
          Standard Terms - By Category
        </Heading1>
        <Grid $desktop="25 25 25 25" $verticalAlign="top">
          <div>
            <Body1>
              <strong>Asset</strong>
            </Body1>
            <Body1>Line 1</Body1>
            <Body1>Line 2</Body1>
            <Body1>Line 3</Body1>
            <Body1>Line 4</Body1>
            <Body1>Machine</Body1>
            <Body1>
              <strong>Counts</strong>
            </Body1>
            <Body1>Accepted</Body1>
            <Body1>Accidents</Body1>
            <Body1>Actual</Body1>
            <Body1>Actual / Hour</Body1>
            <Body1>Actual / Shift</Body1>
            <Body1>Count (Hour)</Body1>
            <Body1>Count (Shift)</Body1>
            <Body1>Good Count</Body1>
            <Body1>Reject Count</Body1>
            <Body1>Rejected</Body1>
            <Body1>Total Count</Body1>
            <Body1>Total Feet</Body1>
            <Body1>Total Yards</Body1>
            <Body1>Unit Count</Body1>
            <Body1>Weekly Total</Body1>
          </div>
          <div>
            <Body1>
              <strong>Cycle Times</strong>
            </Body1>
            <Body1>Average Cycle</Body1>
            <Body1>Current Cycle</Body1>
            <Body1>Cycle Time</Body1>
            <Body1>Last Cycle</Body1>
            <Body1>Target Cycle</Body1>
            <Body1>
              <strong>Goal</strong>
            </Body1>
            <Body1>Goal</Body1>
            <Body1>Goal (Daily)</Body1>
            <Body1>Goal (Hour)</Body1>
            <Body1>Goal (Job)</Body1>
            <Body1>Goal (Monthly)</Body1>
            <Body1>Goal (Shift)</Body1>
            <Body1>Goal (Weekly)</Body1>
            <Body1>Pieces to Goal</Body1>
            <Body1>Scheduled</Body1>
            <Body1>
              <strong>Miscellaneous</strong>
            </Body1>
            <Body1>Next WO</Body1>
            <Body1>WO</Body1>
            <Body1>Work Order #</Body1>
            <Body1>WIP</Body1>
            <Body1>
              <strong>OEE</strong>
            </Body1>
            <Body1>Availability</Body1>
            <Body1>OEE %</Body1>
            <Body1>Performance</Body1>
            <Body1>Quality %</Body1>
          </div>
          <div>
            <Body1>
              <strong>Production Times</strong>
            </Body1>
            <Body1>Down Time</Body1>
            <Body1>Event DT</Body1>
            <Body1>Run Time</Body1>
            <Body1>Setup Time</Body1>
            <Body1>Shift DT</Body1>
            <Body1>Standby Time</Body1>
            <Body1>Total DT</Body1>
            <Body1>Total Time</Body1>
            <Body1>Up Time</Body1>
            <Body1>Up Time %</Body1>
            <Body1>Wait Time</Body1>
            <Body1>
              <strong>Quality</strong>
            </Body1>
            <Body1>Quality %</Body1>
            <Body1>Scrap %</Body1>
            <Body1>
              <strong>Rates</strong>
            </Body1>
            <Body1>Average Speed</Body1>
            <Body1>Average Rate</Body1>
            <Body1>Feet / Min</Body1>
            <Body1>Line Speed</Body1>
            <Body1>Run Rate</Body1>
          </div>
          <div>
            <Body1>
              <strong>Shift</strong>
            </Body1>
            <Body1>Current Shift</Body1>
            <Body1>Last Shift</Body1>
            <Body1>Shift A</Body1>
            <Body1>Shift B</Body1>
            <Body1>Shift C</Body1>
            <Body1>Shift DT</Body1>
            <Body1>
              <strong>Target</strong>
            </Body1>
            <Body1>Difference</Body1>
            <Body1>Efficiency</Body1>
            <Body1>Pace</Body1>
            <Body1>Target</Body1>
            <Body1>Target / Hour</Body1>
            <Body1>Target Count</Body1>
            <Body1>Takt Target</Body1>
            <Body1>Takt Time</Body1>
            <Body1>Variance</Body1>
            <Body1>Week Target</Body1>
            <Body1>
              <strong>Time and Date</strong>
            </Body1>
            <Body1>Date</Body1>
            <Body1>Day</Body1>
            <Body1>Last Hour</Body1>
            <Body1>Month</Body1>
            <Body1>Time</Body1>
            <Body1>Week</Body1>
          </div>
        </Grid>
      </Section>
    </Page>
  );
};

export default XL600LegendPlates;

export function Head() {
  return (
    <Seo
      title="XL600 Interchangeable Legend Plates"
      description="See how you can tailor the XL600 to your application with interchangeable legend plates featuring terms of your choice."
    />
  );
}

export const query = graphql`
  query {
    vorneXl600Image: file(relativePath: { eq: "vorne-xl600-image.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
  }
`;
